import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import { isElement } from 'react-is';

function defaultGetOptionLabel(option) {
  return typeof option === 'string' ? option : _typeof(option) === 'object' && !!option && 'label' in option ? option.label : isElement(option) ? option : "".concat(option);
}

export default defaultGetOptionLabel;
//# sourceMappingURL=default-get-option-label.esm.js.map
